const $ = jQuery

export default function SmoothScroll (element, customOffset = 0) {
  const offset = customOffset !== 0 ? customOffset : getHeaderHeight()
  $('html, body').animate({
    scrollTop: $(element).offset().top - offset
  }, 800)
}

function getHeaderHeight () {
  let height = 0
  const HEADER = document.getElementById('main_header')
  HEADER && (height += HEADER.getBoundingClientRect().height)
  const ADMIN_BAR = document.getElementById('wpadminbar')
  ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
  return height
}
